<template>
  <div>
    <DialogBase
      title="Thêm tài khoản ngân hàng"
      :visible.sync="isOpenAddAccountBankToBrandDialog"
      width="550px"
      panel-icon="el-icon-bank"
      panel-title="LIÊN KẾT TÀI KHOẢN NGÂN HÀNG CÓ SẴN"
      panel-subtitle="Chọn đại lý quản lý và tài khoản ngân hàng API có sẵn để thực hiện liên kết."
      :confirm-loading="loading.submit"
      confirm-text="Xác nhận thêm"
      cancel-text="Hủy bỏ"
      @before-close="handleClose"
      @cancel="handleClose"
      @confirm="submitForm"
      @open="handleOpen"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="top"
        class="modern-form"
      >
        <el-form-item label="Chọn Đại lý quản lý" prop="idxCompany">
          <el-select
            v-model="formData.idxCompany"
            filterable
            clearable
            placeholder="Chọn đại lý..."
            class="full-width"
          >
            <el-option
              v-for="item in companies"
              :key="item.idxCompany"
              :value="item.idxCompany"
              :label="item.companyName"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Chọn Tài khoản ngân hàng API" prop="idBank">
          <el-select
            v-model="formData.idBank"
            filterable
            clearable
            placeholder="Chọn tài khoản..."
            class="full-width"
          >
            <el-option
              v-for="item in banks"
              :key="item.idBank"
              :value="item.idBank"
              :label="item.bankName"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "AddAccountBankToBrandDialog",
  components: { DialogBase },
  props: {
    isOpenAddAccountBankToBrandDialog: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      formData: {
        idBank: "",
        idxCompany: ""
      },
      companies: [],
      banks: [],
      rules: {
        idxCompany: [
          {
            required: true,
            message: "Đại lý không được để trống",
            trigger: "change"
          }
        ],
        idBank: [
          {
            required: true,
            message: "Tài khoản không được để trống",
            trigger: "change"
          }
        ]
      },
      loading: {
        submit: false
      }
    };
  },

  methods: {
    handleClose() {
      this.formData.idBank = "";
      this.formData.idxCompany = "";
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    
    handleOpen() {
      this.findAllCompanyActive();
      this.findAllBanksActive();
    },
    
    async findAllCompanyActive() {
      try {
        const resp = await sePayConnectionService.findAllCompaniesActive();
        this.companies = resp.data.data || [];
      } catch (err) {
        console.error(err);
      }
    },
    
    async findAllBanksActive() {
      try {
        const resp = await sePayConnectionService.findAllBanksAPIActive();
        this.banks = resp.data.data || [];
      } catch (err) {
        console.error(err);
      }
    },
    
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          let data = {
            idxCompany: this.formData.idxCompany,
            idBank: Number(this.formData.idBank)
          };
          try {
            const resp = await sePayConnectionService.addBanksByAdmin(data);
            if (resp.data.status === 200) {
              NotifyMessage.leftCornerNotificationSuccess("Thêm mới thành công!");
            } else {
              NotifyMessage.leftCornerNotificationError("Thêm mới thất bại!");
            }
            this.handleClose();
          } catch (err) {
            console.error(err);
          } finally {
            this.loading.submit = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modern-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  /deep/ .el-input__inner {
    border-radius: 8px;
    height: 40px;
  }
}

.full-width {
  width: 100% !important;
  
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}
</style>